import * as React from "react";
import { SiteModel } from "src/model/model";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { SchemaType, fetchArticles, fetchSanityCredits } from "src/modules/sanityApi";
import { SanityImage } from "sanity-image";
import { SocialMediaIcon } from "src/components/spriteWrappers";
import { SocialMediaLink } from "src/components/socialMediaLink";
import {useEffect} from "react";
import "src/styles/credits.css";
import { Link } from "react-router-dom";

export const Credits = observer(({session}: {session: SiteModel}) => {
	React.useEffect(() => {
		const fetchCredits = async () => {
			if (!session.creditsHaveLoaded) {
				try {
					console.log("No credits loaded, fetching...");
					const fetchedPosts = await fetchSanityCredits();
					console.log(fetchedPosts);
					session.setCredits(fetchedPosts);
				} catch (error) {
					console.error("Error fetching credits:", error);
				}
			}
		};

		fetchCredits().then(() => toJS(session.credits));
	}, [session]);

	// credits bör ha en hierarkisk struktur där varje produkt i stil med:
	// PRODUKT > Kategorier av roller > Personer och deras roller
	// t.ex. Hanakotoba > Musicians > Ohara - Composition
	// Varje produkt bör då motsvaras av ett dokument i Sanity

	return (
		<CreditsView
		credits={session.credits}
		/>
	);
});

function ScrollToHashElement({ offset = 100 }) {
  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) return;

    const observer = new MutationObserver((mutations, obs) => {
      const target = document.getElementById(hash);
      if (target) {
        const rect = target.getBoundingClientRect();
        const scrollTop = window.pageYOffset + rect.top - offset;

        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        });

        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [offset]);

  return null;
}


function CreditsView(props){
	
	// make sure the user views the page from the top
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])

	return (
		<main className="standard-width main-credits">
		<ScrollToHashElement offset={80} />
        <h1>Credits</h1>
        <div className="credits-container">
			{props.credits?.map(creditsCategory => {

				const indices = [1, 2, 3, 4, 5, 6, 7, 8, 9];
				const subcategories = indices.map(index => toJS(creditsCategory[`category_${index}`])).filter(subcategory => !!subcategory);

				return (
					<React.Fragment key={creditsCategory.slug.current}>
						<CreditsContainer  
						title={creditsCategory.name}
						slug={creditsCategory.slug.current}
						subcategories={subcategories}
						/>
					</React.Fragment>
				)

			})}
        </div>
    </main>
	)
}

function CreditsContainer(props){
	console.log(props);
	return ( 
	<div 
	className="credits-wrapper">
		
		<h2 className="credits-title" id={props.slug}>{props.title}</h2>
		<div className="creditees-container">
			{props.subcategories?.map(subcategory => {
				return (
					<div className={"credits-subcategory"} key={subcategory.type._ref}>
						<h3>{subcategory.type.name}</h3>
						<hr/>
						{subcategory.creditees.map(creditee => {
							return <div className="creditee" key={creditee._key}>

								<Link to={creditee.creditee.link}>{creditee.creditee.name}</Link>
								<span>{creditee.role}</span>

							</div>
						})}
						
					</div>
				)
			})}
		</div>

	</div>

	)
}